import AddOnSquareLine from "./svgs/add-on-square-line.svg?react";
import AddTagLine from "./svgs/add-tag-line.svg?react";
import AddUserLine from "./svgs/add-user-line.svg?react";
import AiListGenerated from "./svgs/ai-list-generated.svg?react";
import AlignCenterLine from "./svgs/align-center-line.svg?react";
import AlignLeftLine from "./svgs/align-left-line.svg?react";
import AlignRightLine from "./svgs/align-right-line.svg?react";
import AlignTopLine from "./svgs/align-top-line.svg?react";
import AnnotationMessages5ChatLine from "./svgs/annotation-messages-5-chat-line.svg?react";
import AppleFill from "./svgs/apple-fill.svg?react";
import ArchiveAttachment from "./svgs/archive-attachment.svg?react";
import ArchiveLine from "./svgs/archive-line.svg?react";
import ArrowCircleBrokenRightLine from "./svgs/arrow-circle-broken-right-line.svg?react";
import ArrowDown2Fill from "./svgs/arrow-down-2-fill.svg?react";
import ArrowDownMdLine from "./svgs/arrow-down-md-line.svg?react";
import ArrowRightLine from "./svgs/arrow-right-line.svg?react";
import ArrowUpDownLine from "./svgs/arrow-up-down-line.svg?react";
import ArrowUpLight from "./svgs/arrow-up-light.svg?react";
import ArrowUpMdFill from "./svgs/arrow-up-md-fill.svg?react";
import ArrowUpMdLine from "./svgs/arrow-up-md-line.svg?react";
import ArrowUpRightLongSquareLine from "./svgs/arrow-up-right-long-square-line.svg?react";
import ArrowUpRightMdLine from "./svgs/arrow-up-right-md-line.svg?react";
import ArrowsDiagonalExpandLine from "./svgs/arrows-diagonal-expand-line.svg?react";
import AtomLight from "./svgs/atom-light.svg?react";
import AtomLine from "./svgs/atom-line.svg?react";
import AttachLine from "./svgs/attach-line.svg?react";
import AttachedTicketLine from "./svgs/attached-ticket-line.svg?react";
import AttachmentStackDark from "./svgs/attachment-stack-dark.svg?react";
import AttachmentStackLight from "./svgs/attachment-stack-light.svg?react";
import AudioAttachment from "./svgs/audio-attachment.svg?react";
import BankCardCheckLine from "./svgs/bank-card-check-line.svg?react";
import BankCardDoubleLine from "./svgs/bank-card-double-line.svg?react";
import BankCardExclamationLine from "./svgs/bank-card-exclamation-line.svg?react";
import BankCardSettingsLine from "./svgs/bank-card-settings-line.svg?react";
import BellLogLine from "./svgs/bell-log-line.svg?react";
import BirdieAiLine from "./svgs/birdie-ai-line.svg?react";
import BirdwatchIconAvatar from "./svgs/birdwatch-icon-avatar.svg?react";
import BoardTasksLine from "./svgs/board-tasks-line.svg?react";
import BoldLine from "./svgs/bold-line.svg?react";
import BoltCircleLine from "./svgs/bolt-circle-line.svg?react";
import BookCoverBirdieDark from "./svgs/book-cover-birdie-dark.svg?react";
import BookCoverBirdieLight from "./svgs/book-cover-birdie-light.svg?react";
import BookOpenLine from "./svgs/book-open-line.svg?react";
import BoxArchiveDark from "./svgs/box-archive-dark.svg?react";
import BoxArchiveLight from "./svgs/box-archive-light.svg?react";
import BoxArrowRightLongFill from "./svgs/box-arrow-right-long-fill.svg?react";
import BoxArrowRightLongLine from "./svgs/box-arrow-right-long-line.svg?react";
import BuildingOffice1Line from "./svgs/building-office-1-line.svg?react";
import BuildingOffice2Line from "./svgs/building-office-2-line.svg?react";
import BuildingOfficeLine from "./svgs/building-office-line.svg?react";
import BulletedListLine from "./svgs/bulleted-list-line.svg?react";
import Calendar1Line from "./svgs/calendar-1-line.svg?react";
import Calendar2Line from "./svgs/calendar-2-line.svg?react";
import Calendar3Line from "./svgs/calendar-3-line.svg?react";
import Calendar4Fill from "./svgs/calendar-4-fill.svg?react";
import Calendar4Line from "./svgs/calendar-4-line.svg?react";
import CalendarCheckLine from "./svgs/calendar-check-line.svg?react";
import CalendarCloseFill from "./svgs/calendar-close-fill.svg?react";
import CalendarCloseLine from "./svgs/calendar-close-line.svg?react";
import CalendarDashCircleLine from "./svgs/calendar-dash-circle-line.svg?react";
import CalendarDescriptionLine from "./svgs/calendar-description-line.svg?react";
import CalendarDotsArrowUpLine from "./svgs/calendar-dots-arrow-up-line.svg?react";
import CalendarDotsCheckLine from "./svgs/calendar-dots-check-line.svg?react";
import CalendarDotsCloseLine from "./svgs/calendar-dots-close-line.svg?react";
import CalendarDotsEditLine from "./svgs/calendar-dots-edit-line.svg?react";
import CalendarDotsRefreshLine from "./svgs/calendar-dots-refresh-line.svg?react";
import CalendarDotsTimeLine from "./svgs/calendar-dots-time-line.svg?react";
import CalendarEditLine from "./svgs/calendar-edit-line.svg?react";
import CalendarForwardLine from "./svgs/calendar-forward-line.svg?react";
import CalendarGoogleLight from "./svgs/calendar-google-light.svg?react";
import CalendarLine from "./svgs/calendar-line.svg?react";
import CalendarNullLight from "./svgs/calendar-null-light.svg?react";
import CalendarPlusLine from "./svgs/calendar-plus-line.svg?react";
import CalendarQuarterLine from "./svgs/calendar-quarter-line.svg?react";
import CalendarRefreshLine from "./svgs/calendar-refresh-line.svg?react";
import CalendarTime1Line from "./svgs/calendar-time-1-line.svg?react";
import CalendarTimeLine from "./svgs/calendar-time-line.svg?react";
import CalendarToDoLine from "./svgs/calendar-to-do-line.svg?react";
import CalendarYearLine from "./svgs/calendar-year-line.svg?react";
import CallPhoneLine from "./svgs/call-phone-line.svg?react";
import CallUs from "./svgs/call-us.svg?react";
import CarSideLine from "./svgs/car-side-line.svg?react";
import CardAlipay from "./svgs/card-alipay.svg?react";
import CardAmex from "./svgs/card-amex.svg?react";
import CardBank from "./svgs/card-bank.svg?react";
import CardDiners from "./svgs/card-diners.svg?react";
import CardDiscover from "./svgs/card-discover.svg?react";
import CardElo from "./svgs/card-elo.svg?react";
import CardHiper from "./svgs/card-hiper.svg?react";
import CardHipercard from "./svgs/card-hipercard.svg?react";
import CardJcb from "./svgs/card-jcb.svg?react";
import CardMaestro from "./svgs/card-maestro.svg?react";
import CardMastercard from "./svgs/card-mastercard.svg?react";
import CardMir from "./svgs/card-mir.svg?react";
import CardPaypal from "./svgs/card-paypal.svg?react";
import CardUnionpay from "./svgs/card-unionpay.svg?react";
import CardVisa from "./svgs/card-visa.svg?react";
import CardsDollarFill from "./svgs/cards-dollar-fill.svg?react";
import CardsDollarLine from "./svgs/cards-dollar-line.svg?react";
import CardsListFill from "./svgs/cards-list-fill.svg?react";
import CardsListLine from "./svgs/cards-list-line.svg?react";
import CaretDownMdLine from "./svgs/caret-down-md-line.svg?react";
import CaretLeftMdLine from "./svgs/caret-left-md-line.svg?react";
import CaretRightMdLine from "./svgs/caret-right-md-line.svg?react";
import CaretUpMdLine from "./svgs/caret-up-md-line.svg?react";
import CatalogPanelLine from "./svgs/catalog-panel-line.svg?react";
import Chat2Fill from "./svgs/chat-2-fill.svg?react";
import Chat2Line from "./svgs/chat-2-line.svg?react";
import ChatBadge3Line from "./svgs/chat-badge-3-line.svg?react";
import ChatBubbleChartDownLine from "./svgs/chat-bubble-chart-down-line.svg?react";
import ChatBubbleChartFlatLine from "./svgs/chat-bubble-chart-flat-line.svg?react";
import ChatBubbleChartUpLine from "./svgs/chat-bubble-chart-up-line.svg?react";
import ChatBubbleFill from "./svgs/chat-bubble-fill.svg?react";
import ChatBubbleLine from "./svgs/chat-bubble-line.svg?react";
import ChatBubbleQuestionMarkLine from "./svgs/chat-bubble-question-mark-line.svg?react";
import ChatCommentLine from "./svgs/chat-comment-line.svg?react";
import ChatModeFloating from "./svgs/chat-mode-floating.svg?react";
import ChatModeFullscreen from "./svgs/chat-mode-fullscreen.svg?react";
import ChatModeSidebar from "./svgs/chat-mode-sidebar.svg?react";
import ChatPanelCollapse from "./svgs/chat-panel-collapse.svg?react";
import ChatPanelMinimize from "./svgs/chat-panel-minimize.svg?react";
import ChatSmileLight from "./svgs/chat-smile-light.svg?react";
import ChatSquareBadgeLine from "./svgs/chat-square-badge-line.svg?react";
import ChatSquareHappyLine from "./svgs/chat-square-happy-line.svg?react";
import CheckBadgeFill from "./svgs/check-badge-fill.svg?react";
import CheckCircleFill from "./svgs/check-circle-fill.svg?react";
import CheckCircleLine from "./svgs/check-circle-line.svg?react";
import CheckList from "./svgs/check-list.svg?react";
import CheckListDark from "./svgs/check-list-dark.svg?react";
import CheckSquareLine from "./svgs/check-square-line.svg?react";
import CheckboxChecked from "./svgs/checkbox-checked.svg?react";
import CheckboxCheckedEnabled from "./svgs/checkbox-checked-enabled.svg?react";
import CheckboxIndeterminateEnabled from "./svgs/checkbox-indeterminate-enabled.svg?react";
import ChecklistDark from "./svgs/checklist-dark.svg?react";
import ChecklistLight from "./svgs/checklist-light.svg?react";
import Checkmark from "./svgs/checkmark.svg?react";
import CheckmarkLine from "./svgs/checkmark-line.svg?react";
import ChevronContractMdVericalLine from "./svgs/chevron-contract-md-verical-line.svg?react";
import ChevronDownCondensedLine from "./svgs/chevron-down-condensed-line.svg?react";
import ChevronDownLine from "./svgs/chevron-down-line.svg?react";
import ChevronExpandMdVericalLine from "./svgs/chevron-expand-md-verical-line.svg?react";
import ChevronLeftLine from "./svgs/chevron-left-line.svg?react";
import ChevronLeftMdLine from "./svgs/chevron-left-md-line.svg?react";
import ChevronRightCondensed from "./svgs/chevron-right-condensed.svg?react";
import ChevronRightDuoLine from "./svgs/chevron-right-duo-line.svg?react";
import ChevronRightLine from "./svgs/chevron-right-line.svg?react";
import ChevronRightMdLine from "./svgs/chevron-right-md-line.svg?react";
import ChevronUpCondensedLine from "./svgs/chevron-up-condensed-line.svg?react";
import ChevronUpDuoLine from "./svgs/chevron-up-duo-line.svg?react";
import ChevronUpLine from "./svgs/chevron-up-line.svg?react";
import CircleComplete from "./svgs/circle-complete.svg?react";
import CircleHalfLine from "./svgs/circle-half-line.svg?react";
import CircleLine from "./svgs/circle-line.svg?react";
import CircleMessageArrowDownLine from "./svgs/circle-message-arrow-down-line.svg?react";
import CircleMessageBadgeLine from "./svgs/circle-message-badge-line.svg?react";
import CircleMessageCheckLine from "./svgs/circle-message-check-line.svg?react";
import CircleMessageFill from "./svgs/circle-message-fill.svg?react";
import CircleMessageLine from "./svgs/circle-message-line.svg?react";
import CircleMessageTimeLine from "./svgs/circle-message-time-line.svg?react";
import CircleMessageUserLine from "./svgs/circle-message-user-line.svg?react";
import CircleMessageVoiceLine from "./svgs/circle-message-voice-line.svg?react";
import CircleNotComplete from "./svgs/circle-not-complete.svg?react";
import ClearTextLine from "./svgs/clear-text-line.svg?react";
import Clipboard2LinesLine from "./svgs/clipboard-2-lines-line.svg?react";
import ClipboardCheckFill from "./svgs/clipboard-check-fill.svg?react";
import ClipboardCheckLine from "./svgs/clipboard-check-line.svg?react";
import ClipboardLine from "./svgs/clipboard-line.svg?react";
import ClipboardListLine from "./svgs/clipboard-list-line.svg?react";
import ClipboardPencilDark from "./svgs/clipboard-pencil-dark.svg?react";
import ClipboardPencilLight from "./svgs/clipboard-pencil-light.svg?react";
import ClipboardTasksLine from "./svgs/clipboard-tasks-line.svg?react";
import ClockOffSleepFill from "./svgs/clock-off-sleep-fill.svg?react";
import ClockOffSleepLine from "./svgs/clock-off-sleep-line.svg?react";
import CloseCircleFill from "./svgs/close-circle-fill.svg?react";
import CloseCircleLine from "./svgs/close-circle-line.svg?react";
import CloseLeftLine from "./svgs/close-left-line.svg?react";
import CloseLine from "./svgs/close-line.svg?react";
import CloseRemove from "./svgs/close-remove.svg?react";
import CloseSquareLine from "./svgs/close-square-line.svg?react";
import CloudUploadLine from "./svgs/cloud-upload-line.svg?react";
import ClubCardRepeatLine from "./svgs/club-card-repeat-line.svg?react";
import Code1Line from "./svgs/code-1-line.svg?react";
import Code2Line from "./svgs/code-2-line.svg?react";
import Code3Line from "./svgs/code-3-line.svg?react";
import CoinsStackFill from "./svgs/coins-stack-fill.svg?react";
import CoinsStackLine from "./svgs/coins-stack-line.svg?react";
import CommentsDark from "./svgs/comments-dark.svg?react";
import CommentsLight from "./svgs/comments-light.svg?react";
import CompoundLine from "./svgs/compound-line.svg?react";
import ConnectingCableDark from "./svgs/connecting-cable-dark.svg?react";
import ConnectingCableLight from "./svgs/connecting-cable-light.svg?react";
import ConnectingCableLine from "./svgs/connecting-cable-line.svg?react";
import CopyLine from "./svgs/copy-line.svg?react";
import CornerRightDownLine from "./svgs/corner-right-down-line.svg?react";
import CounterClockwiseUndoLine from "./svgs/counter-clockwise-undo-line.svg?react";
import Cube4Line from "./svgs/cube-4-line.svg?react";
import CurveArrowRightLine from "./svgs/curve-arrow-right-line.svg?react";
import DashCircleLine from "./svgs/dash-circle-line.svg?react";
import DayCalendarDark from "./svgs/day-calendar-dark.svg?react";
import DayCalendarLight from "./svgs/day-calendar-light.svg?react";
import DayListDark from "./svgs/day-list-dark.svg?react";
import DayListLight from "./svgs/day-list-light.svg?react";
import DayTimelineDark from "./svgs/day-timeline-dark.svg?react";
import DayTimelineLight from "./svgs/day-timeline-light.svg?react";
import DeleteLine from "./svgs/delete-line.svg?react";
import DeskCalendar4DotsLine from "./svgs/desk-calendar-4-dots-line.svg?react";
import DeskCalendarArrowRightLine from "./svgs/desk-calendar-arrow-right-line.svg?react";
import DeskCalendarTimeRightLine from "./svgs/desk-calendar-time-right-line.svg?react";
import DeskCalendarXmarkLine from "./svgs/desk-calendar-xmark-line.svg?react";
import DiamondLine from "./svgs/diamond-line.svg?react";
import DiamondStarFill from "./svgs/diamond-star-fill.svg?react";
import DocsLine from "./svgs/docs-line.svg?react";
import Document2Line from "./svgs/document-2-line.svg?react";
import DocumentBadgePlusLine from "./svgs/document-badge-plus-line.svg?react";
import DocumentBarChartFill from "./svgs/document-bar-chart-fill.svg?react";
import DocumentBarChartLine from "./svgs/document-bar-chart-line.svg?react";
import DocumentBoard2Line from "./svgs/document-board-2-line.svg?react";
import DocumentClockLine from "./svgs/document-clock-line.svg?react";
import DocumentLine from "./svgs/document-line.svg?react";
import DocumentLineColor from "./svgs/document-line-color.svg?react";
import DocumentScanLine from "./svgs/document-scan-line.svg?react";
import DocumentSquare2LeftLinesLine from "./svgs/document-square-2-left-lines-line.svg?react";
import DocumentUploadLine from "./svgs/document-upload-line.svg?react";
import Dollar2Fill from "./svgs/dollar-2-fill.svg?react";
import DollarBadgeFill from "./svgs/dollar-badge-fill.svg?react";
import DollarBadgeLine from "./svgs/dollar-badge-line.svg?react";
import DollarCircleAddLine from "./svgs/dollar-circle-add-line.svg?react";
import DollarCircleFill from "./svgs/dollar-circle-fill.svg?react";
import DollarCircleLine from "./svgs/dollar-circle-line.svg?react";
import DollarCircleRemoveLine from "./svgs/dollar-circle-remove-line.svg?react";
import DollarDocumentFill from "./svgs/dollar-document-fill.svg?react";
import DollarDocumentLine from "./svgs/dollar-document-line.svg?react";
import DollarReceiveLine from "./svgs/dollar-receive-line.svg?react";
import DotEcryption from "./svgs/dot-ecryption.svg?react";
import DotFill from "./svgs/dot-fill.svg?react";
import DownloadCloud2Line from "./svgs/download-cloud-2-line.svg?react";
import DownloadLine from "./svgs/download-line.svg?react";
import Draggable from "./svgs/draggable.svg?react";
import EditAiLine from "./svgs/edit-ai-line.svg?react";
import EditProfileLine from "./svgs/edit-profile-line.svg?react";
import EmailLine from "./svgs/email-line.svg?react";
import EmailSendLine from "./svgs/email-send-line.svg?react";
import EmojiFrustratedLine from "./svgs/emoji-frustrated-line.svg?react";
import EmojiGrinningFaceLine from "./svgs/emoji-grinning-face-line.svg?react";
import EmojiHappyHeartLine from "./svgs/emoji-happy-heart-line.svg?react";
import EmojiSlightlyFrowningLine from "./svgs/emoji-slightly-frowning-line.svg?react";
import EmojiSmilingAddLine from "./svgs/emoji-smiling-add-line.svg?react";
import EmojiSmilingLine from "./svgs/emoji-smiling-line.svg?react";
import EncryptionLine from "./svgs/encryption-line.svg?react";
import EnlargeExpandVerticalLine from "./svgs/enlarge-expand-vertical-line.svg?react";
import EqualLine from "./svgs/equal-line.svg?react";
import ExpensesDark from "./svgs/expenses-dark.svg?react";
import ExpensesLight from "./svgs/expenses-light.svg?react";
import ExploreLine from "./svgs/explore-line.svg?react";
import Eye3Line from "./svgs/eye-3-line.svg?react";
import EyeHideLine from "./svgs/eye-hide-line.svg?react";
import EyeOpenLine from "./svgs/eye-open-line.svg?react";
import EyesDark from "./svgs/eyes-dark.svg?react";
import EyesLight from "./svgs/eyes-light.svg?react";
import FeatherColorLine from "./svgs/feather-color-line.svg?react";
import FeatherLine from "./svgs/feather-line.svg?react";
import FileFolder from "./svgs/file-folder.svg?react";
import FileFolderDark from "./svgs/file-folder-dark.svg?react";
import FileFolderLight from "./svgs/file-folder-light.svg?react";
import FileMagnifyingGlass from "./svgs/file-magnifying-glass.svg?react";
import Filter2Line from "./svgs/filter-2-line.svg?react";
import FilterLine from "./svgs/filter-line.svg?react";
import FilterObjectsLine from "./svgs/filter-objects-line.svg?react";
import FinancingBookDark from "./svgs/financing-book-dark.svg?react";
import FinancingBookLight from "./svgs/financing-book-light.svg?react";
import FingersClapCheck from "./svgs/fingers-clap-check.svg?react";
import Fire3 from "./svgs/fire-3.svg?react";
import FireFill from "./svgs/fire-fill.svg?react";
import FireLine from "./svgs/fire-line.svg?react";
import Flag from "./svgs/flag.svg?react";
import FlagFill from "./svgs/flag-fill.svg?react";
import FlagLine from "./svgs/flag-line.svg?react";
import FlagOnSquareLine from "./svgs/flag-on-square-line.svg?react";
import FlashFill from "./svgs/flash-fill.svg?react";
import FlashLine from "./svgs/flash-line.svg?react";
import FocusFrame1Line from "./svgs/focus-frame-1-line.svg?react";
import FocusFrame2Line from "./svgs/focus-frame-2-line.svg?react";
import FocusFrame3Line from "./svgs/focus-frame-3-line.svg?react";
import FolderFileAnalysisFill from "./svgs/folder-file-analysis-fill.svg?react";
import FolderFileAnalysisLine from "./svgs/folder-file-analysis-line.svg?react";
import FolderFileFill from "./svgs/folder-file-fill.svg?react";
import FolderFileImageLine from "./svgs/folder-file-image-line.svg?react";
import FolderFileLine from "./svgs/folder-file-line.svg?react";
import FolderFileSearchInLine from "./svgs/folder-file-search-in-line.svg?react";
import Forbidden from "./svgs/forbidden.svg?react";
import ForbiddenSignLine from "./svgs/forbidden-sign-line.svg?react";
import FounderAvatarGroup from "./svgs/founder-avatar-group.svg?react";
import FullOutHorizontalLine from "./svgs/full-out-horizontal-line.svg?react";
import GiftCardFill from "./svgs/gift-card-fill.svg?react";
import GiftCardLine from "./svgs/gift-card-line.svg?react";
import Gmail from "./svgs/gmail.svg?react";
import GoogleCalendarColor from "./svgs/google-calendar-color.svg?react";
import GoogleFill from "./svgs/google-fill.svg?react";
import GoogleLine from "./svgs/google-line.svg?react";
import GooglePlayFill from "./svgs/google-play-fill.svg?react";
import GridInterface1Line from "./svgs/grid-interface-1-line.svg?react";
import GridInterface2Line from "./svgs/grid-interface-2-line.svg?react";
import GridInterface3Line from "./svgs/grid-interface-3-line.svg?react";
import GridInterface4Line from "./svgs/grid-interface-4-line.svg?react";
import GridInterfaceStackLine from "./svgs/grid-interface-stack-line.svg?react";
import H1Line from "./svgs/h1-line.svg?react";
import H2Line from "./svgs/h2-line.svg?react";
import H3Line from "./svgs/h3-line.svg?react";
import HamburgerMenuLine from "./svgs/hamburger-menu-line.svg?react";
import HeartRateLine from "./svgs/heart-rate-line.svg?react";
import HexagonLine from "./svgs/hexagon-line.svg?react";
import HomeBlueprintDark from "./svgs/home-blueprint-dark.svg?react";
import HomeBlueprintLight from "./svgs/home-blueprint-light.svg?react";
import HomeDark from "./svgs/home-dark.svg?react";
import HomeHeart from "./svgs/home-heart.svg?react";
import HomeKeyFill from "./svgs/home-key-fill.svg?react";
import HomeLight from "./svgs/home-light.svg?react";
import HomeLine from "./svgs/home-line.svg?react";
import HomePlainCaretDownLine from "./svgs/home-plain-caret-down-line.svg?react";
import HomeRequestDark from "./svgs/home-request-dark.svg?react";
import HomeRequestLight from "./svgs/home-request-light.svg?react";
import HomeRoofSmileFill from "./svgs/home-roof-smile-fill.svg?react";
import HomeRoofSmileLine from "./svgs/home-roof-smile-line.svg?react";
import HomeSearchLine from "./svgs/home-search-line.svg?react";
import HomeSmileLine from "./svgs/home-smile-line.svg?react";
import HorizontalBarChartLine from "./svgs/horizontal-bar-chart-line.svg?react";
import HouseFill from "./svgs/house-fill.svg?react";
import IdSquareLine from "./svgs/id-square-line.svg?react";
import ImageAttachment from "./svgs/image-attachment.svg?react";
import ImageDark from "./svgs/image-dark.svg?react";
import ImageEditLine from "./svgs/image-edit-line.svg?react";
import ImageLight from "./svgs/image-light.svg?react";
import ImagePlusLine from "./svgs/image-plus-line.svg?react";
import ImageSquareLine from "./svgs/image-square-line.svg?react";
import ImageUploadLine from "./svgs/image-upload-line.svg?react";
import InboxFill from "./svgs/inbox-fill.svg?react";
import InboxLine from "./svgs/inbox-line.svg?react";
import InfoCircleFill from "./svgs/info-circle-fill.svg?react";
import InfoCircleLine from "./svgs/info-circle-line.svg?react";
import ItalicLine from "./svgs/italic-line.svg?react";
import Lamp2Fill from "./svgs/lamp-2-fill.svg?react";
import LampFill from "./svgs/lamp-fill.svg?react";
import LampLine from "./svgs/lamp-line.svg?react";
import LampShineLine from "./svgs/lamp-shine-line.svg?react";
import LayerOnDashLine from "./svgs/layer-on-dash-line.svg?react";
import LayersLine from "./svgs/layers-line.svg?react";
import Leaves1Line from "./svgs/leaves-1-line.svg?react";
import LeavesLine from "./svgs/leaves-line.svg?react";
import LeftLine from "./svgs/left-line.svg?react";
import LightDarkModeLine from "./svgs/light-dark-mode-line.svg?react";
import LightbulbLight from "./svgs/lightbulb-light.svg?react";
import LinkLine from "./svgs/link-line.svg?react";
import LinkUnlinkLine from "./svgs/link-unlink-line.svg?react";
import ListCheckUncheckFill from "./svgs/list-check-uncheck-fill.svg?react";
import ListCheckUncheckLine from "./svgs/list-check-uncheck-line.svg?react";
import ListItemDark from "./svgs/list-item-dark.svg?react";
import ListItemLight from "./svgs/list-item-light.svg?react";
import LoadingLine from "./svgs/loading-line.svg?react";
import LocationCheckFill from "./svgs/location-check-fill.svg?react";
import LocationFill from "./svgs/location-fill.svg?react";
import LocationLine from "./svgs/location-line.svg?react";
import Lock from "./svgs/lock.svg?react";
import LockFill from "./svgs/lock-fill.svg?react";
import LogoSymbol from "./svgs/logo-symbol.svg?react";
import LogoWithText from "./svgs/logo-with-text.svg?react";
import LogoutLine from "./svgs/logout-line.svg?react";
import LyricsAi from "./svgs/lyrics-ai.svg?react";
import MacLaptopNotebook from "./svgs/mac-laptop-notebook.svg?react";
import MagnifyingGlassDark from "./svgs/magnifying-glass-dark.svg?react";
import MagnifyingGlassHandDark from "./svgs/magnifying-glass-hand-dark.svg?react";
import MagnifyingGlassHandLight from "./svgs/magnifying-glass-hand-light.svg?react";
import MagnifyingGlassLight from "./svgs/magnifying-glass-light.svg?react";
import MapLocation from "./svgs/map-location.svg?react";
import MapSquareFill from "./svgs/map-square-fill.svg?react";
import MemberStatusBillingFill from "./svgs/member-status-billing-fill.svg?react";
import MemberStatusCancelledFill from "./svgs/member-status-cancelled-fill.svg?react";
import MemberStatusDeferredFill from "./svgs/member-status-deferred-fill.svg?react";
import MemberStatusDoneFill from "./svgs/member-status-done-fill.svg?react";
import MemberStatusInProgressFill from "./svgs/member-status-in-progress-fill.svg?react";
import MemberStatusNewFill from "./svgs/member-status-new-fill.svg?react";
import MemberStatusQuotingFill from "./svgs/member-status-quoting-fill.svg?react";
import MemberStatusReviewingFill from "./svgs/member-status-reviewing-fill.svg?react";
import MemberStatusSchedulingFill from "./svgs/member-status-scheduling-fill.svg?react";
import MemberStatusWaitingFill from "./svgs/member-status-waiting-fill.svg?react";
import MentionLine from "./svgs/mention-line.svg?react";
import MenuGripLine from "./svgs/menu-grip-line.svg?react";
import MenuLine from "./svgs/menu-line.svg?react";
import MessageForwardFill from "./svgs/message-forward-fill.svg?react";
import MessagesDark from "./svgs/messages-dark.svg?react";
import MessagesLight from "./svgs/messages-light.svg?react";
import MessagesLine from "./svgs/messages-line.svg?react";
import MicrophoneFill from "./svgs/microphone-fill.svg?react";
import MicrophoneLine from "./svgs/microphone-line.svg?react";
import Microsoft365 from "./svgs/microsoft-365.svg?react";
import MobileFrameDark from "./svgs/mobile-frame-dark.svg?react";
import MobileFrameLight from "./svgs/mobile-frame-light.svg?react";
import MoneyPaperFill from "./svgs/money-paper-fill.svg?react";
import MoneyPaperLine from "./svgs/money-paper-line.svg?react";
import MonitorWebcamVideoFill from "./svgs/monitor-webcam-video-fill.svg?react";
import MoonLine from "./svgs/moon-line.svg?react";
import MoreFill from "./svgs/more-fill.svg?react";
import MoreLine from "./svgs/more-line.svg?react";
import MultitaskingLine from "./svgs/multitasking-line.svg?react";
import NavigationArrowLine from "./svgs/navigation-arrow-line.svg?react";
import NewNotificationLine from "./svgs/new-notification-line.svg?react";
import NoResultSoftDark from "./svgs/no-result-soft-dark.svg?react";
import NoResultSoftLight from "./svgs/no-result-soft-light.svg?react";
import NoUserLine from "./svgs/no-user-line.svg?react";
import NotFound from "./svgs/not-found.svg?react";
import NotificationCheckLine from "./svgs/notification-check-line.svg?react";
import NotificationFill from "./svgs/notification-fill.svg?react";
import NotificationLine from "./svgs/notification-line.svg?react";
import NotificationPlusLine from "./svgs/notification-plus-line.svg?react";
import NumberedListLine from "./svgs/numbered-list-line.svg?react";
import OnboardingSessionAvatars from "./svgs/onboarding-session-avatars.svg?react";
import OrderTypeBilling from "./svgs/order-type-billing.svg?react";
import OrderTypeNew from "./svgs/order-type-new.svg?react";
import OrderTypeProgress from "./svgs/order-type-progress.svg?react";
import OrderTypeReview from "./svgs/order-type-review.svg?react";
import OrderTypeSchedule from "./svgs/order-type-schedule.svg?react";
import Outlook from "./svgs/outlook.svg?react";
import OwlAiColor from "./svgs/owl-ai-color.svg?react";
import Placeavatarplaceholderdark from "./svgs/PlaceAvatarPlaceholderDark.svg?react";
import Placeavatarplaceholderlight from "./svgs/PlaceAvatarPlaceholderLight.svg?react";
import PaintingPaletteLine from "./svgs/painting-palette-line.svg?react";
import PapePlaneLight from "./svgs/pape-plane-light.svg?react";
import PaperPlaneLight from "./svgs/paper-plane-light.svg?react";
import PasswordSquareLine from "./svgs/password-square-line.svg?react";
import PauseCircleLine from "./svgs/pause-circle-line.svg?react";
import PauseLine from "./svgs/pause-line.svg?react";
import PaymentMethodApplePayDark from "./svgs/payment-method-apple-pay-dark.svg?react";
import PaymentMethodApplePayLight from "./svgs/payment-method-apple-pay-light.svg?react";
import PaymentMethodBankDark from "./svgs/payment-method-bank-dark.svg?react";
import PaymentMethodBankLight from "./svgs/payment-method-bank-light.svg?react";
import PaymentMethodCashDark from "./svgs/payment-method-cash-dark.svg?react";
import PaymentMethodCashLight from "./svgs/payment-method-cash-light.svg?react";
import PaymentMethodCcGenericDark from "./svgs/payment-method-cc-generic-dark.svg?react";
import PaymentMethodCcGenericLight from "./svgs/payment-method-cc-generic-light.svg?react";
import PaymentMethodCreditsDark from "./svgs/payment-method-credits-dark.svg?react";
import PaymentMethodCreditsLight from "./svgs/payment-method-credits-light.svg?react";
import PaymentMethodDepositDark from "./svgs/payment-method-deposit-dark.svg?react";
import PaymentMethodDepositLight from "./svgs/payment-method-deposit-light.svg?react";
import PaymentMethodGooglePayDark from "./svgs/payment-method-google-pay-dark.svg?react";
import PaymentMethodGooglePayLight from "./svgs/payment-method-google-pay-light.svg?react";
import PaymentMethodMasterCardDark from "./svgs/payment-method-master-card-dark.svg?react";
import PaymentMethodMasterCardLight from "./svgs/payment-method-master-card-light.svg?react";
import PaymentMethodPaypalDark from "./svgs/payment-method-paypal-dark.svg?react";
import PaymentMethodPaypalLight from "./svgs/payment-method-paypal-light.svg?react";
import PaymentMethodVisaDark from "./svgs/payment-method-visa-dark.svg?react";
import PaymentMethodVisaLight from "./svgs/payment-method-visa-light.svg?react";
import PdfAttachment from "./svgs/pdf-attachment.svg?react";
import Pen from "./svgs/pen.svg?react";
import PenEngineeringLine from "./svgs/pen-engineering-line.svg?react";
import PenLine from "./svgs/pen-line.svg?react";
import PenRulerCrossLine from "./svgs/pen-ruler-cross-line.svg?react";
import PenRulerLine from "./svgs/pen-ruler-line.svg?react";
import PencilLine from "./svgs/pencil-line.svg?react";
import PhoneHandLight from "./svgs/phone-hand-light.svg?react";
import PhoneNumberPad from "./svgs/phone-number-pad.svg?react";
import Pin1Fill from "./svgs/pin-1-fill.svg?react";
import PinLine from "./svgs/pin-line.svg?react";
import PinListLine from "./svgs/pin-list-line.svg?react";
import PinRemoveLine from "./svgs/pin-remove-line.svg?react";
import PlaceCalendarDark from "./svgs/place-calendar-dark.svg?react";
import PlaceCalendarLight from "./svgs/place-calendar-light.svg?react";
import PlaceDark from "./svgs/place-dark.svg?react";
import PlaceHouseIcon from "./svgs/place-house-icon.svg?react";
import PlaceJournal from "./svgs/place-journal.svg?react";
import PlaceJournalDark from "./svgs/place-journal-dark.svg?react";
import PlaceJournalLight from "./svgs/place-journal-light.svg?react";
import PlaceLight from "./svgs/place-light.svg?react";
import PlaceOverview from "./svgs/place-overview.svg?react";
import PlayFill from "./svgs/play-fill.svg?react";
import PlayLine from "./svgs/play-line.svg?react";
import PlusLine from "./svgs/plus-line.svg?react";
import PocketBookHeartLine from "./svgs/pocket-book-heart-line.svg?react";
import PptAttachment from "./svgs/ppt-attachment.svg?react";
import PrimaryContactLight from "./svgs/primary-contact-light.svg?react";
import ProfitDark from "./svgs/profit-dark.svg?react";
import ProfitLight from "./svgs/profit-light.svg?react";
import ProgressCircularLine15 from "./svgs/progress-circular-line-1-5.svg?react";
import ProgressCircularLine25 from "./svgs/progress-circular-line-2-5.svg?react";
import ProgressCircularLine35 from "./svgs/progress-circular-line-3-5.svg?react";
import ProgressCircularLine45 from "./svgs/progress-circular-line-4-5.svg?react";
import ProgressCircularLine55 from "./svgs/progress-circular-line-5-5.svg?react";
import ProgressDark from "./svgs/progress-dark.svg?react";
import ProgressLight from "./svgs/progress-light.svg?react";
import Qrcodebirdwatchapp from "./svgs/QRCodeBirdwatchApp.svg?react";
import QrCode from "./svgs/qr-code.svg?react";
import QrScanLine from "./svgs/qr-scan-line.svg?react";
import QuestionMarkCircleFill from "./svgs/question-mark-circle-fill.svg?react";
import QuestionMarkCircleLine from "./svgs/question-mark-circle-line.svg?react";
import QuotationCloseLine from "./svgs/quotation-close-line.svg?react";
import QuotationOpenLine from "./svgs/quotation-open-line.svg?react";
import ReceiptBillCloseLine from "./svgs/receipt-bill-close-line.svg?react";
import ReceiptBillLine from "./svgs/receipt-bill-line.svg?react";
import ReceiptBillTimeFill from "./svgs/receipt-bill-time-fill.svg?react";
import ReceiptBillTimeLine from "./svgs/receipt-bill-time-line.svg?react";
import ReceiptDark from "./svgs/receipt-dark.svg?react";
import ReceiptLight from "./svgs/receipt-light.svg?react";
import ReceiptPrintDark from "./svgs/receipt-print-dark.svg?react";
import ReceiptPrintLight from "./svgs/receipt-print-light.svg?react";
import RecordCircleLine from "./svgs/record-circle-line.svg?react";
import RecordVideoLine from "./svgs/record-video-line.svg?react";
import RectangleRoundFill from "./svgs/rectangle-round-fill.svg?react";
import RedoLine from "./svgs/redo-line.svg?react";
import RefreshLoadLeftLine from "./svgs/refresh-load-left-line.svg?react";
import RefreshRightLine from "./svgs/refresh-right-line.svg?react";
import RefreshSquareLeftLine from "./svgs/refresh-square-left-line.svg?react";
import ReplayIconLine from "./svgs/replay-icon-line.svg?react";
import ReplyShareLeftLine from "./svgs/reply-share-left-line.svg?react";
import ReportBook from "./svgs/report-book.svg?react";
import ReportBookDark from "./svgs/report-book-dark.svg?react";
import ReportBookLight from "./svgs/report-book-light.svg?react";
import ReportJournalDark from "./svgs/report-journal-dark.svg?react";
import ReportJournalLight from "./svgs/report-journal-light.svg?react";
import RightDownCircleFill from "./svgs/right-down-circle-fill.svg?react";
import RightLine from "./svgs/right-line.svg?react";
import RouteLine from "./svgs/route-line.svg?react";
import SafeBoxFill from "./svgs/safe-box-fill.svg?react";
import SafeBoxLine from "./svgs/safe-box-line.svg?react";
import ScanSquareSliderLine from "./svgs/scan-square-slider-line.svg?react";
import ScopeLight from "./svgs/scope-light.svg?react";
import SearchLibraryLine from "./svgs/search-library-line.svg?react";
import SearchLine from "./svgs/search-line.svg?react";
import SearchSquareTitleLine from "./svgs/search-square-title-line.svg?react";
import SeenCheckmarkLine from "./svgs/seen-checkmark-line.svg?react";
import SendFill from "./svgs/send-fill.svg?react";
import SendLine from "./svgs/send-line.svg?react";
import SendMessageLine from "./svgs/send-message-line.svg?react";
import SettingLine from "./svgs/setting-line.svg?react";
import SettingToolQuareLine from "./svgs/setting-tool-quare-line.svg?react";
import ShareSquareLine from "./svgs/share-square-line.svg?react";
import SheetAttachment from "./svgs/sheet-attachment.svg?react";
import Shield1Line from "./svgs/shield-1-line.svg?react";
import ShieldDoneLine from "./svgs/shield-done-line.svg?react";
import ShieldFill from "./svgs/shield-fill.svg?react";
import ShieldLine from "./svgs/shield-line.svg?react";
import ShoppingBagPlusLine from "./svgs/shopping-bag-plus-line.svg?react";
import ShoppingCartCheckFill from "./svgs/shopping-cart-check-fill.svg?react";
import ShoppingCartLine from "./svgs/shopping-cart-line.svg?react";
import SideToLeftSideLine from "./svgs/side-to-left-side-line.svg?react";
import SideToRightSideFill from "./svgs/side-to-right-side-fill.svg?react";
import SideToRightSideLine from "./svgs/side-to-right-side-line.svg?react";
import SmartphoneLine from "./svgs/smartphone-line.svg?react";
import SmsAppColor from "./svgs/sms-app-color.svg?react";
import SnowLine from "./svgs/snow-line.svg?react";
import SortDownLine from "./svgs/sort-down-line.svg?react";
import SortsComplete from "./svgs/sorts-complete.svg?react";
import SpaceRocketLine from "./svgs/space-rocket-line.svg?react";
import SquareMessage1VoiceLine from "./svgs/square-message-1-voice-line.svg?react";
import StackCheckDark from "./svgs/stack-check-dark.svg?react";
import StackCheckLight from "./svgs/stack-check-light.svg?react";
import StarGlowingColorLine from "./svgs/star-glowing-color-line.svg?react";
import StarGlowingLine from "./svgs/star-glowing-line.svg?react";
import StarLine from "./svgs/star-line.svg?react";
import StartAChat from "./svgs/start-a-chat.svg?react";
import StickerLine from "./svgs/sticker-line.svg?react";
import StopSquareFill from "./svgs/stop-square-fill.svg?react";
import StopwatchFlagLine from "./svgs/stopwatch-flag-line.svg?react";
import StoreFill from "./svgs/store-fill.svg?react";
import StoreLine from "./svgs/store-line.svg?react";
import StrikethroughLine from "./svgs/strikethrough-line.svg?react";
import SubscriptionDark from "./svgs/subscription-dark.svg?react";
import SubscriptionLight from "./svgs/subscription-light.svg?react";
import SubtractDashLine from "./svgs/subtract-dash-line.svg?react";
import Sun1Line from "./svgs/sun-1-line.svg?react";
import SunLine from "./svgs/sun-line.svg?react";
import SunOffLine from "./svgs/sun-off-line.svg?react";
import SunriseLine from "./svgs/sunrise-line.svg?react";
import SunsetLine from "./svgs/sunset-line.svg?react";
import SwapHorizontalSquareLine from "./svgs/swap-horizontal-square-line.svg?react";
import TabClick from "./svgs/tab-click.svg?react";
import TableSquareLine from "./svgs/table-square-line.svg?react";
import TagLeftLine from "./svgs/tag-left-line.svg?react";
import TagLine from "./svgs/tag-line.svg?react";
import TagRightLine from "./svgs/tag-right-line.svg?react";
import TargetCircleLine from "./svgs/target-circle-line.svg?react";
import TextAi from "./svgs/text-ai.svg?react";
import TextAttachment from "./svgs/text-attachment.svg?react";
import TextDirectionLine from "./svgs/text-direction-line.svg?react";
import TextFieldLine from "./svgs/text-field-line.svg?react";
import TextLine from "./svgs/text-line.svg?react";
import ThumbDislikeFill from "./svgs/thumb-dislike-fill.svg?react";
import ThumbDislikeLine from "./svgs/thumb-dislike-line.svg?react";
import ThumbLikeFill from "./svgs/thumb-like-fill.svg?react";
import ThumbLikeLine from "./svgs/thumb-like-line.svg?react";
import ThumbUpDark from "./svgs/thumb-up-dark.svg?react";
import ThumbUpLight from "./svgs/thumb-up-light.svg?react";
import TimeBookDark from "./svgs/time-book-dark.svg?react";
import TimeBookLight from "./svgs/time-book-light.svg?react";
import TimeCircleFill from "./svgs/time-circle-fill.svg?react";
import TimeCircleLine from "./svgs/time-circle-line.svg?react";
import TimeDashLine from "./svgs/time-dash-line.svg?react";
import TimeTrackDark from "./svgs/time-track-dark.svg?react";
import TimeTrackLight from "./svgs/time-track-light.svg?react";
import TimerCloseLine from "./svgs/timer-close-line.svg?react";
import TimerFill from "./svgs/timer-fill.svg?react";
import TimerLine from "./svgs/timer-line.svg?react";
import TitleCaseLine from "./svgs/title-case-line.svg?react";
import TwoUsersFill from "./svgs/two-users-fill.svg?react";
import TwoUsersLine from "./svgs/two-users-line.svg?react";
import UnderlineLine from "./svgs/underline-line.svg?react";
import UndoLine from "./svgs/undo-line.svg?react";
import UniversityLine from "./svgs/university-line.svg?react";
import UpdateLeftLine from "./svgs/update-left-line.svg?react";
import UpdateRightLine from "./svgs/update-right-line.svg?react";
import UploadLine from "./svgs/upload-line.svg?react";
import UserBackgroundBlurNoneLine from "./svgs/user-background-blur-none-line.svg?react";
import UserBackgroundBlurThickLine from "./svgs/user-background-blur-thick-line.svg?react";
import UserBackgroundBlurThinLine from "./svgs/user-background-blur-thin-line.svg?react";
import UserCardDark from "./svgs/user-card-dark.svg?react";
import UserCardLight from "./svgs/user-card-light.svg?react";
import UserCircleFill from "./svgs/user-circle-fill.svg?react";
import UserCircleLine from "./svgs/user-circle-line.svg?react";
import UserIdCardDark from "./svgs/user-id-card-dark.svg?react";
import UserIdCardHangDark from "./svgs/user-id-card-hang-dark.svg?react";
import UserIdCardHangLight from "./svgs/user-id-card-hang-light.svg?react";
import UserIdCardLight from "./svgs/user-id-card-light.svg?react";
import UserInformationIdFill from "./svgs/user-information-id-fill.svg?react";
import UserInformationIdLine from "./svgs/user-information-id-line.svg?react";
import UserLine from "./svgs/user-line.svg?react";
import UserPenLine from "./svgs/user-pen-line.svg?react";
import UserScanLine from "./svgs/user-scan-line.svg?react";
import UserShieldLine from "./svgs/user-shield-line.svg?react";
import UserStarLine from "./svgs/user-star-line.svg?react";
import UserStripeLine from "./svgs/user-stripe-line.svg?react";
import UsersLine from "./svgs/users-line.svg?react";
import VideoAttachment from "./svgs/video-attachment.svg?react";
import VideoCameraLine from "./svgs/video-camera-line.svg?react";
import VideoDark from "./svgs/video-dark.svg?react";
import VideoLight from "./svgs/video-light.svg?react";
import WaitListDark from "./svgs/wait-list-dark.svg?react";
import WaitListLight from "./svgs/wait-list-light.svg?react";
import WalkFill from "./svgs/walk-fill.svg?react";
import WalletCardsDark from "./svgs/wallet-cards-dark.svg?react";
import WalletCardsLight from "./svgs/wallet-cards-light.svg?react";
import WarningCircleFill from "./svgs/warning-circle-fill.svg?react";
import WarningCircleLine from "./svgs/warning-circle-line.svg?react";
import WarningSquareLine from "./svgs/warning-square-line.svg?react";
import WarningTriangleLine from "./svgs/warning-triangle-line.svg?react";
import WavingHandLine from "./svgs/waving-hand-line.svg?react";
import WhatsappColor from "./svgs/whatsapp-color.svg?react";
import WindowDockedSidepanelLine from "./svgs/window-docked-sidepanel-line.svg?react";
import WordAttachment from "./svgs/word-attachment.svg?react";
import WorkFill from "./svgs/work-fill.svg?react";
import WorldNetwork from "./svgs/world-network.svg?react";
import WrenchLine from "./svgs/wrench-line.svg?react";
import Yahoo from "./svgs/yahoo.svg?react";
import ZoomInLine from "./svgs/zoom-in-line.svg?react";
import ZoomOutLine from "./svgs/zoom-out-line.svg?react";
import withBwIconProps from "./withBwIconProps";

export const BwPlaceavatarplaceholderdark = withBwIconProps(
  Placeavatarplaceholderdark,
);
export const BwPlaceavatarplaceholderlight = withBwIconProps(
  Placeavatarplaceholderlight,
);
export const BwQrcodebirdwatchapp = withBwIconProps(Qrcodebirdwatchapp);
export const BwAddOnSquareLine = withBwIconProps(AddOnSquareLine);
export const BwAddTagLine = withBwIconProps(AddTagLine);
export const BwAddUserLine = withBwIconProps(AddUserLine);
export const BwAiListGenerated = withBwIconProps(AiListGenerated);
export const BwAlignCenterLine = withBwIconProps(AlignCenterLine);
export const BwAlignLeftLine = withBwIconProps(AlignLeftLine);
export const BwAlignRightLine = withBwIconProps(AlignRightLine);
export const BwAlignTopLine = withBwIconProps(AlignTopLine);
export const BwAnnotationMessages5ChatLine = withBwIconProps(
  AnnotationMessages5ChatLine,
);
export const BwAppleFill = withBwIconProps(AppleFill);
export const BwArchiveAttachment = withBwIconProps(ArchiveAttachment);
export const BwArchiveLine = withBwIconProps(ArchiveLine);
export const BwArrowCircleBrokenRightLine = withBwIconProps(
  ArrowCircleBrokenRightLine,
);
export const BwArrowDown2Fill = withBwIconProps(ArrowDown2Fill);
export const BwArrowDownMdLine = withBwIconProps(ArrowDownMdLine);
export const BwArrowRightLine = withBwIconProps(ArrowRightLine);
export const BwArrowUpDownLine = withBwIconProps(ArrowUpDownLine);
export const BwArrowUpLight = withBwIconProps(ArrowUpLight);
export const BwArrowUpMdFill = withBwIconProps(ArrowUpMdFill);
export const BwArrowUpMdLine = withBwIconProps(ArrowUpMdLine);
export const BwArrowUpRightLongSquareLine = withBwIconProps(
  ArrowUpRightLongSquareLine,
);
export const BwArrowUpRightMdLine = withBwIconProps(ArrowUpRightMdLine);
export const BwArrowsDiagonalExpandLine = withBwIconProps(
  ArrowsDiagonalExpandLine,
);
export const BwAtomLight = withBwIconProps(AtomLight);
export const BwAtomLine = withBwIconProps(AtomLine);
export const BwAttachLine = withBwIconProps(AttachLine);
export const BwAttachedTicketLine = withBwIconProps(AttachedTicketLine);
export const BwAttachmentStackDark = withBwIconProps(AttachmentStackDark);
export const BwAttachmentStackLight = withBwIconProps(AttachmentStackLight);
export const BwAudioAttachment = withBwIconProps(AudioAttachment);
export const BwBankCardCheckLine = withBwIconProps(BankCardCheckLine);
export const BwBankCardDoubleLine = withBwIconProps(BankCardDoubleLine);
export const BwBankCardExclamationLine = withBwIconProps(
  BankCardExclamationLine,
);
export const BwBankCardSettingsLine = withBwIconProps(BankCardSettingsLine);
export const BwBellLogLine = withBwIconProps(BellLogLine);
export const BwBirdieAiLine = withBwIconProps(BirdieAiLine);
export const BwBirdwatchIconAvatar = withBwIconProps(BirdwatchIconAvatar);
export const BwBoardTasksLine = withBwIconProps(BoardTasksLine);
export const BwBoldLine = withBwIconProps(BoldLine);
export const BwBoltCircleLine = withBwIconProps(BoltCircleLine);
export const BwBookCoverBirdieDark = withBwIconProps(BookCoverBirdieDark);
export const BwBookCoverBirdieLight = withBwIconProps(BookCoverBirdieLight);
export const BwBookOpenLine = withBwIconProps(BookOpenLine);
export const BwBoxArchiveDark = withBwIconProps(BoxArchiveDark);
export const BwBoxArchiveLight = withBwIconProps(BoxArchiveLight);
export const BwBoxArrowRightLongFill = withBwIconProps(BoxArrowRightLongFill);
export const BwBoxArrowRightLongLine = withBwIconProps(BoxArrowRightLongLine);
export const BwBuildingOffice1Line = withBwIconProps(BuildingOffice1Line);
export const BwBuildingOffice2Line = withBwIconProps(BuildingOffice2Line);
export const BwBuildingOfficeLine = withBwIconProps(BuildingOfficeLine);
export const BwBulletedListLine = withBwIconProps(BulletedListLine);
export const BwCalendar1Line = withBwIconProps(Calendar1Line);
export const BwCalendar2Line = withBwIconProps(Calendar2Line);
export const BwCalendar3Line = withBwIconProps(Calendar3Line);
export const BwCalendar4Fill = withBwIconProps(Calendar4Fill);
export const BwCalendar4Line = withBwIconProps(Calendar4Line);
export const BwCalendarCheckLine = withBwIconProps(CalendarCheckLine);
export const BwCalendarCloseFill = withBwIconProps(CalendarCloseFill);
export const BwCalendarCloseLine = withBwIconProps(CalendarCloseLine);
export const BwCalendarDashCircleLine = withBwIconProps(CalendarDashCircleLine);
export const BwCalendarDescriptionLine = withBwIconProps(
  CalendarDescriptionLine,
);
export const BwCalendarDotsArrowUpLine = withBwIconProps(
  CalendarDotsArrowUpLine,
);
export const BwCalendarDotsCheckLine = withBwIconProps(CalendarDotsCheckLine);
export const BwCalendarDotsCloseLine = withBwIconProps(CalendarDotsCloseLine);
export const BwCalendarDotsEditLine = withBwIconProps(CalendarDotsEditLine);
export const BwCalendarDotsRefreshLine = withBwIconProps(
  CalendarDotsRefreshLine,
);
export const BwCalendarDotsTimeLine = withBwIconProps(CalendarDotsTimeLine);
export const BwCalendarEditLine = withBwIconProps(CalendarEditLine);
export const BwCalendarForwardLine = withBwIconProps(CalendarForwardLine);
export const BwCalendarGoogleLight = withBwIconProps(CalendarGoogleLight);
export const BwCalendarLine = withBwIconProps(CalendarLine);
export const BwCalendarNullLight = withBwIconProps(CalendarNullLight);
export const BwCalendarPlusLine = withBwIconProps(CalendarPlusLine);
export const BwCalendarQuarterLine = withBwIconProps(CalendarQuarterLine);
export const BwCalendarRefreshLine = withBwIconProps(CalendarRefreshLine);
export const BwCalendarTime1Line = withBwIconProps(CalendarTime1Line);
export const BwCalendarTimeLine = withBwIconProps(CalendarTimeLine);
export const BwCalendarToDoLine = withBwIconProps(CalendarToDoLine);
export const BwCalendarYearLine = withBwIconProps(CalendarYearLine);
export const BwCallPhoneLine = withBwIconProps(CallPhoneLine);
export const BwCallUs = withBwIconProps(CallUs);
export const BwCarSideLine = withBwIconProps(CarSideLine);
export const BwCardAlipay = withBwIconProps(CardAlipay);
export const BwCardAmex = withBwIconProps(CardAmex);
export const BwCardBank = withBwIconProps(CardBank);
export const BwCardDiners = withBwIconProps(CardDiners);
export const BwCardDiscover = withBwIconProps(CardDiscover);
export const BwCardElo = withBwIconProps(CardElo);
export const BwCardHiper = withBwIconProps(CardHiper);
export const BwCardHipercard = withBwIconProps(CardHipercard);
export const BwCardJcb = withBwIconProps(CardJcb);
export const BwCardMaestro = withBwIconProps(CardMaestro);
export const BwCardMastercard = withBwIconProps(CardMastercard);
export const BwCardMir = withBwIconProps(CardMir);
export const BwCardPaypal = withBwIconProps(CardPaypal);
export const BwCardUnionpay = withBwIconProps(CardUnionpay);
export const BwCardVisa = withBwIconProps(CardVisa);
export const BwCardsDollarFill = withBwIconProps(CardsDollarFill);
export const BwCardsDollarLine = withBwIconProps(CardsDollarLine);
export const BwCardsListFill = withBwIconProps(CardsListFill);
export const BwCardsListLine = withBwIconProps(CardsListLine);
export const BwCaretDownMdLine = withBwIconProps(CaretDownMdLine);
export const BwCaretLeftMdLine = withBwIconProps(CaretLeftMdLine);
export const BwCaretRightMdLine = withBwIconProps(CaretRightMdLine);
export const BwCaretUpMdLine = withBwIconProps(CaretUpMdLine);
export const BwCatalogPanelLine = withBwIconProps(CatalogPanelLine);
export const BwChat2Fill = withBwIconProps(Chat2Fill);
export const BwChat2Line = withBwIconProps(Chat2Line);
export const BwChatBadge3Line = withBwIconProps(ChatBadge3Line);
export const BwChatBubbleChartDownLine = withBwIconProps(
  ChatBubbleChartDownLine,
);
export const BwChatBubbleChartFlatLine = withBwIconProps(
  ChatBubbleChartFlatLine,
);
export const BwChatBubbleChartUpLine = withBwIconProps(ChatBubbleChartUpLine);
export const BwChatBubbleFill = withBwIconProps(ChatBubbleFill);
export const BwChatBubbleLine = withBwIconProps(ChatBubbleLine);
export const BwChatBubbleQuestionMarkLine = withBwIconProps(
  ChatBubbleQuestionMarkLine,
);
export const BwChatCommentLine = withBwIconProps(ChatCommentLine);
export const BwChatModeFloating = withBwIconProps(ChatModeFloating);
export const BwChatModeFullscreen = withBwIconProps(ChatModeFullscreen);
export const BwChatModeSidebar = withBwIconProps(ChatModeSidebar);
export const BwChatPanelCollapse = withBwIconProps(ChatPanelCollapse);
export const BwChatPanelMinimize = withBwIconProps(ChatPanelMinimize);
export const BwChatSmileLight = withBwIconProps(ChatSmileLight);
export const BwChatSquareBadgeLine = withBwIconProps(ChatSquareBadgeLine);
export const BwChatSquareHappyLine = withBwIconProps(ChatSquareHappyLine);
export const BwCheckBadgeFill = withBwIconProps(CheckBadgeFill);
export const BwCheckCircleFill = withBwIconProps(CheckCircleFill);
export const BwCheckCircleLine = withBwIconProps(CheckCircleLine);
export const BwCheckListDark = withBwIconProps(CheckListDark);
export const BwCheckList = withBwIconProps(CheckList);
export const BwCheckSquareLine = withBwIconProps(CheckSquareLine);
export const BwCheckboxCheckedEnabled = withBwIconProps(CheckboxCheckedEnabled);
export const BwCheckboxChecked = withBwIconProps(CheckboxChecked);
export const BwCheckboxIndeterminateEnabled = withBwIconProps(
  CheckboxIndeterminateEnabled,
);
export const BwChecklistDark = withBwIconProps(ChecklistDark);
export const BwChecklistLight = withBwIconProps(ChecklistLight);
export const BwCheckmarkLine = withBwIconProps(CheckmarkLine);
export const BwCheckmark = withBwIconProps(Checkmark);
export const BwChevronContractMdVericalLine = withBwIconProps(
  ChevronContractMdVericalLine,
);
export const BwChevronDownCondensedLine = withBwIconProps(
  ChevronDownCondensedLine,
);
export const BwChevronDownLine = withBwIconProps(ChevronDownLine);
export const BwChevronExpandMdVericalLine = withBwIconProps(
  ChevronExpandMdVericalLine,
);
export const BwChevronLeftLine = withBwIconProps(ChevronLeftLine);
export const BwChevronLeftMdLine = withBwIconProps(ChevronLeftMdLine);
export const BwChevronRightCondensed = withBwIconProps(ChevronRightCondensed);
export const BwChevronRightDuoLine = withBwIconProps(ChevronRightDuoLine);
export const BwChevronRightLine = withBwIconProps(ChevronRightLine);
export const BwChevronRightMdLine = withBwIconProps(ChevronRightMdLine);
export const BwChevronUpCondensedLine = withBwIconProps(ChevronUpCondensedLine);
export const BwChevronUpDuoLine = withBwIconProps(ChevronUpDuoLine);
export const BwChevronUpLine = withBwIconProps(ChevronUpLine);
export const BwCircleComplete = withBwIconProps(CircleComplete);
export const BwCircleHalfLine = withBwIconProps(CircleHalfLine);
export const BwCircleLine = withBwIconProps(CircleLine);
export const BwCircleMessageArrowDownLine = withBwIconProps(
  CircleMessageArrowDownLine,
);
export const BwCircleMessageBadgeLine = withBwIconProps(CircleMessageBadgeLine);
export const BwCircleMessageCheckLine = withBwIconProps(CircleMessageCheckLine);
export const BwCircleMessageFill = withBwIconProps(CircleMessageFill);
export const BwCircleMessageLine = withBwIconProps(CircleMessageLine);
export const BwCircleMessageTimeLine = withBwIconProps(CircleMessageTimeLine);
export const BwCircleMessageUserLine = withBwIconProps(CircleMessageUserLine);
export const BwCircleMessageVoiceLine = withBwIconProps(CircleMessageVoiceLine);
export const BwCircleNotComplete = withBwIconProps(CircleNotComplete);
export const BwClearTextLine = withBwIconProps(ClearTextLine);
export const BwClipboard2LinesLine = withBwIconProps(Clipboard2LinesLine);
export const BwClipboardCheckFill = withBwIconProps(ClipboardCheckFill);
export const BwClipboardCheckLine = withBwIconProps(ClipboardCheckLine);
export const BwClipboardLine = withBwIconProps(ClipboardLine);
export const BwClipboardListLine = withBwIconProps(ClipboardListLine);
export const BwClipboardPencilDark = withBwIconProps(ClipboardPencilDark);
export const BwClipboardPencilLight = withBwIconProps(ClipboardPencilLight);
export const BwClipboardTasksLine = withBwIconProps(ClipboardTasksLine);
export const BwClockOffSleepFill = withBwIconProps(ClockOffSleepFill);
export const BwClockOffSleepLine = withBwIconProps(ClockOffSleepLine);
export const BwCloseCircleFill = withBwIconProps(CloseCircleFill);
export const BwCloseCircleLine = withBwIconProps(CloseCircleLine);
export const BwCloseLeftLine = withBwIconProps(CloseLeftLine);
export const BwCloseLine = withBwIconProps(CloseLine);
export const BwCloseRemove = withBwIconProps(CloseRemove);
export const BwCloseSquareLine = withBwIconProps(CloseSquareLine);
export const BwCloudUploadLine = withBwIconProps(CloudUploadLine);
export const BwClubCardRepeatLine = withBwIconProps(ClubCardRepeatLine);
export const BwCode1Line = withBwIconProps(Code1Line);
export const BwCode2Line = withBwIconProps(Code2Line);
export const BwCode3Line = withBwIconProps(Code3Line);
export const BwCoinsStackFill = withBwIconProps(CoinsStackFill);
export const BwCoinsStackLine = withBwIconProps(CoinsStackLine);
export const BwCommentsDark = withBwIconProps(CommentsDark);
export const BwCommentsLight = withBwIconProps(CommentsLight);
export const BwCompoundLine = withBwIconProps(CompoundLine);
export const BwConnectingCableDark = withBwIconProps(ConnectingCableDark);
export const BwConnectingCableLight = withBwIconProps(ConnectingCableLight);
export const BwConnectingCableLine = withBwIconProps(ConnectingCableLine);
export const BwCopyLine = withBwIconProps(CopyLine);
export const BwCornerRightDownLine = withBwIconProps(CornerRightDownLine);
export const BwCounterClockwiseUndoLine = withBwIconProps(
  CounterClockwiseUndoLine,
);
export const BwCube4Line = withBwIconProps(Cube4Line);
export const BwCurveArrowRightLine = withBwIconProps(CurveArrowRightLine);
export const BwDashCircleLine = withBwIconProps(DashCircleLine);
export const BwDayCalendarDark = withBwIconProps(DayCalendarDark);
export const BwDayCalendarLight = withBwIconProps(DayCalendarLight);
export const BwDayListDark = withBwIconProps(DayListDark);
export const BwDayListLight = withBwIconProps(DayListLight);
export const BwDayTimelineDark = withBwIconProps(DayTimelineDark);
export const BwDayTimelineLight = withBwIconProps(DayTimelineLight);
export const BwDeleteLine = withBwIconProps(DeleteLine);
export const BwDeskCalendar4DotsLine = withBwIconProps(DeskCalendar4DotsLine);
export const BwDeskCalendarArrowRightLine = withBwIconProps(
  DeskCalendarArrowRightLine,
);
export const BwDeskCalendarTimeRightLine = withBwIconProps(
  DeskCalendarTimeRightLine,
);
export const BwDeskCalendarXmarkLine = withBwIconProps(DeskCalendarXmarkLine);
export const BwDiamondLine = withBwIconProps(DiamondLine);
export const BwDiamondStarFill = withBwIconProps(DiamondStarFill);
export const BwDocsLine = withBwIconProps(DocsLine);
export const BwDocument2Line = withBwIconProps(Document2Line);
export const BwDocumentBadgePlusLine = withBwIconProps(DocumentBadgePlusLine);
export const BwDocumentBarChartFill = withBwIconProps(DocumentBarChartFill);
export const BwDocumentBarChartLine = withBwIconProps(DocumentBarChartLine);
export const BwDocumentBoard2Line = withBwIconProps(DocumentBoard2Line);
export const BwDocumentClockLine = withBwIconProps(DocumentClockLine);
export const BwDocumentLineColor = withBwIconProps(DocumentLineColor);
export const BwDocumentLine = withBwIconProps(DocumentLine);
export const BwDocumentScanLine = withBwIconProps(DocumentScanLine);
export const BwDocumentSquare2LeftLinesLine = withBwIconProps(
  DocumentSquare2LeftLinesLine,
);
export const BwDocumentUploadLine = withBwIconProps(DocumentUploadLine);
export const BwDollar2Fill = withBwIconProps(Dollar2Fill);
export const BwDollarBadgeFill = withBwIconProps(DollarBadgeFill);
export const BwDollarBadgeLine = withBwIconProps(DollarBadgeLine);
export const BwDollarCircleAddLine = withBwIconProps(DollarCircleAddLine);
export const BwDollarCircleFill = withBwIconProps(DollarCircleFill);
export const BwDollarCircleLine = withBwIconProps(DollarCircleLine);
export const BwDollarCircleRemoveLine = withBwIconProps(DollarCircleRemoveLine);
export const BwDollarDocumentFill = withBwIconProps(DollarDocumentFill);
export const BwDollarDocumentLine = withBwIconProps(DollarDocumentLine);
export const BwDollarReceiveLine = withBwIconProps(DollarReceiveLine);
export const BwDotEcryption = withBwIconProps(DotEcryption);
export const BwDotFill = withBwIconProps(DotFill);
export const BwDownloadCloud2Line = withBwIconProps(DownloadCloud2Line);
export const BwDownloadLine = withBwIconProps(DownloadLine);
export const BwDraggable = withBwIconProps(Draggable);
export const BwEditAiLine = withBwIconProps(EditAiLine);
export const BwEditProfileLine = withBwIconProps(EditProfileLine);
export const BwEmailLine = withBwIconProps(EmailLine);
export const BwEmailSendLine = withBwIconProps(EmailSendLine);
export const BwEmojiFrustratedLine = withBwIconProps(EmojiFrustratedLine);
export const BwEmojiGrinningFaceLine = withBwIconProps(EmojiGrinningFaceLine);
export const BwEmojiHappyHeartLine = withBwIconProps(EmojiHappyHeartLine);
export const BwEmojiSlightlyFrowningLine = withBwIconProps(
  EmojiSlightlyFrowningLine,
);
export const BwEmojiSmilingAddLine = withBwIconProps(EmojiSmilingAddLine);
export const BwEmojiSmilingLine = withBwIconProps(EmojiSmilingLine);
export const BwEncryptionLine = withBwIconProps(EncryptionLine);
export const BwEnlargeExpandVerticalLine = withBwIconProps(
  EnlargeExpandVerticalLine,
);
export const BwEqualLine = withBwIconProps(EqualLine);
export const BwExpensesDark = withBwIconProps(ExpensesDark);
export const BwExpensesLight = withBwIconProps(ExpensesLight);
export const BwExploreLine = withBwIconProps(ExploreLine);
export const BwEye3Line = withBwIconProps(Eye3Line);
export const BwEyeHideLine = withBwIconProps(EyeHideLine);
export const BwEyeOpenLine = withBwIconProps(EyeOpenLine);
export const BwEyesDark = withBwIconProps(EyesDark);
export const BwEyesLight = withBwIconProps(EyesLight);
export const BwFeatherColorLine = withBwIconProps(FeatherColorLine);
export const BwFeatherLine = withBwIconProps(FeatherLine);
export const BwFileFolderDark = withBwIconProps(FileFolderDark);
export const BwFileFolderLight = withBwIconProps(FileFolderLight);
export const BwFileFolder = withBwIconProps(FileFolder);
export const BwFileMagnifyingGlass = withBwIconProps(FileMagnifyingGlass);
export const BwFilter2Line = withBwIconProps(Filter2Line);
export const BwFilterLine = withBwIconProps(FilterLine);
export const BwFilterObjectsLine = withBwIconProps(FilterObjectsLine);
export const BwFinancingBookDark = withBwIconProps(FinancingBookDark);
export const BwFinancingBookLight = withBwIconProps(FinancingBookLight);
export const BwFingersClapCheck = withBwIconProps(FingersClapCheck);
export const BwFire3 = withBwIconProps(Fire3);
export const BwFireFill = withBwIconProps(FireFill);
export const BwFireLine = withBwIconProps(FireLine);
export const BwFlagFill = withBwIconProps(FlagFill);
export const BwFlagLine = withBwIconProps(FlagLine);
export const BwFlagOnSquareLine = withBwIconProps(FlagOnSquareLine);
export const BwFlag = withBwIconProps(Flag);
export const BwFlashFill = withBwIconProps(FlashFill);
export const BwFlashLine = withBwIconProps(FlashLine);
export const BwFocusFrame1Line = withBwIconProps(FocusFrame1Line);
export const BwFocusFrame2Line = withBwIconProps(FocusFrame2Line);
export const BwFocusFrame3Line = withBwIconProps(FocusFrame3Line);
export const BwFolderFileAnalysisFill = withBwIconProps(FolderFileAnalysisFill);
export const BwFolderFileAnalysisLine = withBwIconProps(FolderFileAnalysisLine);
export const BwFolderFileFill = withBwIconProps(FolderFileFill);
export const BwFolderFileImageLine = withBwIconProps(FolderFileImageLine);
export const BwFolderFileLine = withBwIconProps(FolderFileLine);
export const BwFolderFileSearchInLine = withBwIconProps(FolderFileSearchInLine);
export const BwForbiddenSignLine = withBwIconProps(ForbiddenSignLine);
export const BwForbidden = withBwIconProps(Forbidden);
export const BwFounderAvatarGroup = withBwIconProps(FounderAvatarGroup);
export const BwFullOutHorizontalLine = withBwIconProps(FullOutHorizontalLine);
export const BwGiftCardFill = withBwIconProps(GiftCardFill);
export const BwGiftCardLine = withBwIconProps(GiftCardLine);
export const BwGmail = withBwIconProps(Gmail);
export const BwGoogleCalendarColor = withBwIconProps(GoogleCalendarColor);
export const BwGoogleFill = withBwIconProps(GoogleFill);
export const BwGoogleLine = withBwIconProps(GoogleLine);
export const BwGooglePlayFill = withBwIconProps(GooglePlayFill);
export const BwGridInterface1Line = withBwIconProps(GridInterface1Line);
export const BwGridInterface2Line = withBwIconProps(GridInterface2Line);
export const BwGridInterface3Line = withBwIconProps(GridInterface3Line);
export const BwGridInterface4Line = withBwIconProps(GridInterface4Line);
export const BwGridInterfaceStackLine = withBwIconProps(GridInterfaceStackLine);
export const BwH1Line = withBwIconProps(H1Line);
export const BwH2Line = withBwIconProps(H2Line);
export const BwH3Line = withBwIconProps(H3Line);
export const BwHamburgerMenuLine = withBwIconProps(HamburgerMenuLine);
export const BwHeartRateLine = withBwIconProps(HeartRateLine);
export const BwHexagonLine = withBwIconProps(HexagonLine);
export const BwHomeBlueprintDark = withBwIconProps(HomeBlueprintDark);
export const BwHomeBlueprintLight = withBwIconProps(HomeBlueprintLight);
export const BwHomeDark = withBwIconProps(HomeDark);
export const BwHomeHeart = withBwIconProps(HomeHeart);
export const BwHomeKeyFill = withBwIconProps(HomeKeyFill);
export const BwHomeLight = withBwIconProps(HomeLight);
export const BwHomeLine = withBwIconProps(HomeLine);
export const BwHomePlainCaretDownLine = withBwIconProps(HomePlainCaretDownLine);
export const BwHomeRequestDark = withBwIconProps(HomeRequestDark);
export const BwHomeRequestLight = withBwIconProps(HomeRequestLight);
export const BwHomeRoofSmileFill = withBwIconProps(HomeRoofSmileFill);
export const BwHomeRoofSmileLine = withBwIconProps(HomeRoofSmileLine);
export const BwHomeSearchLine = withBwIconProps(HomeSearchLine);
export const BwHomeSmileLine = withBwIconProps(HomeSmileLine);
export const BwHorizontalBarChartLine = withBwIconProps(HorizontalBarChartLine);
export const BwHouseFill = withBwIconProps(HouseFill);
export const BwIdSquareLine = withBwIconProps(IdSquareLine);
export const BwImageAttachment = withBwIconProps(ImageAttachment);
export const BwImageDark = withBwIconProps(ImageDark);
export const BwImageEditLine = withBwIconProps(ImageEditLine);
export const BwImageLight = withBwIconProps(ImageLight);
export const BwImagePlusLine = withBwIconProps(ImagePlusLine);
export const BwImageSquareLine = withBwIconProps(ImageSquareLine);
export const BwImageUploadLine = withBwIconProps(ImageUploadLine);
export const BwInboxFill = withBwIconProps(InboxFill);
export const BwInboxLine = withBwIconProps(InboxLine);
export const BwInfoCircleFill = withBwIconProps(InfoCircleFill);
export const BwInfoCircleLine = withBwIconProps(InfoCircleLine);
export const BwItalicLine = withBwIconProps(ItalicLine);
export const BwLamp2Fill = withBwIconProps(Lamp2Fill);
export const BwLampFill = withBwIconProps(LampFill);
export const BwLampLine = withBwIconProps(LampLine);
export const BwLampShineLine = withBwIconProps(LampShineLine);
export const BwLayerOnDashLine = withBwIconProps(LayerOnDashLine);
export const BwLayersLine = withBwIconProps(LayersLine);
export const BwLeaves1Line = withBwIconProps(Leaves1Line);
export const BwLeavesLine = withBwIconProps(LeavesLine);
export const BwLeftLine = withBwIconProps(LeftLine);
export const BwLightDarkModeLine = withBwIconProps(LightDarkModeLine);
export const BwLightbulbLight = withBwIconProps(LightbulbLight);
export const BwLinkLine = withBwIconProps(LinkLine);
export const BwLinkUnlinkLine = withBwIconProps(LinkUnlinkLine);
export const BwListCheckUncheckFill = withBwIconProps(ListCheckUncheckFill);
export const BwListCheckUncheckLine = withBwIconProps(ListCheckUncheckLine);
export const BwListItemDark = withBwIconProps(ListItemDark);
export const BwListItemLight = withBwIconProps(ListItemLight);
export const BwLoadingLine = withBwIconProps(LoadingLine);
export const BwLocationCheckFill = withBwIconProps(LocationCheckFill);
export const BwLocationFill = withBwIconProps(LocationFill);
export const BwLocationLine = withBwIconProps(LocationLine);
export const BwLockFill = withBwIconProps(LockFill);
export const BwLock = withBwIconProps(Lock);
export const BwLogoSymbol = withBwIconProps(LogoSymbol);
export const BwLogoWithText = withBwIconProps(LogoWithText);
export const BwLogoutLine = withBwIconProps(LogoutLine);
export const BwLyricsAi = withBwIconProps(LyricsAi);
export const BwMacLaptopNotebook = withBwIconProps(MacLaptopNotebook);
export const BwMagnifyingGlassDark = withBwIconProps(MagnifyingGlassDark);
export const BwMagnifyingGlassHandDark = withBwIconProps(
  MagnifyingGlassHandDark,
);
export const BwMagnifyingGlassHandLight = withBwIconProps(
  MagnifyingGlassHandLight,
);
export const BwMagnifyingGlassLight = withBwIconProps(MagnifyingGlassLight);
export const BwMapLocation = withBwIconProps(MapLocation);
export const BwMapSquareFill = withBwIconProps(MapSquareFill);
export const BwMemberStatusBillingFill = withBwIconProps(
  MemberStatusBillingFill,
);
export const BwMemberStatusCancelledFill = withBwIconProps(
  MemberStatusCancelledFill,
);
export const BwMemberStatusDeferredFill = withBwIconProps(
  MemberStatusDeferredFill,
);
export const BwMemberStatusDoneFill = withBwIconProps(MemberStatusDoneFill);
export const BwMemberStatusInProgressFill = withBwIconProps(
  MemberStatusInProgressFill,
);
export const BwMemberStatusNewFill = withBwIconProps(MemberStatusNewFill);
export const BwMemberStatusQuotingFill = withBwIconProps(
  MemberStatusQuotingFill,
);
export const BwMemberStatusReviewingFill = withBwIconProps(
  MemberStatusReviewingFill,
);
export const BwMemberStatusSchedulingFill = withBwIconProps(
  MemberStatusSchedulingFill,
);
export const BwMemberStatusWaitingFill = withBwIconProps(
  MemberStatusWaitingFill,
);
export const BwMentionLine = withBwIconProps(MentionLine);
export const BwMenuGripLine = withBwIconProps(MenuGripLine);
export const BwMenuLine = withBwIconProps(MenuLine);
export const BwMessageForwardFill = withBwIconProps(MessageForwardFill);
export const BwMessagesDark = withBwIconProps(MessagesDark);
export const BwMessagesLight = withBwIconProps(MessagesLight);
export const BwMessagesLine = withBwIconProps(MessagesLine);
export const BwMicrophoneFill = withBwIconProps(MicrophoneFill);
export const BwMicrophoneLine = withBwIconProps(MicrophoneLine);
export const BwMicrosoft365 = withBwIconProps(Microsoft365);
export const BwMobileFrameDark = withBwIconProps(MobileFrameDark);
export const BwMobileFrameLight = withBwIconProps(MobileFrameLight);
export const BwMoneyPaperFill = withBwIconProps(MoneyPaperFill);
export const BwMoneyPaperLine = withBwIconProps(MoneyPaperLine);
export const BwMonitorWebcamVideoFill = withBwIconProps(MonitorWebcamVideoFill);
export const BwMoonLine = withBwIconProps(MoonLine);
export const BwMoreFill = withBwIconProps(MoreFill);
export const BwMoreLine = withBwIconProps(MoreLine);
export const BwMultitaskingLine = withBwIconProps(MultitaskingLine);
export const BwNavigationArrowLine = withBwIconProps(NavigationArrowLine);
export const BwNewNotificationLine = withBwIconProps(NewNotificationLine);
export const BwNoResultSoftDark = withBwIconProps(NoResultSoftDark);
export const BwNoResultSoftLight = withBwIconProps(NoResultSoftLight);
export const BwNoUserLine = withBwIconProps(NoUserLine);
export const BwNotFound = withBwIconProps(NotFound);
export const BwNotificationCheckLine = withBwIconProps(NotificationCheckLine);
export const BwNotificationFill = withBwIconProps(NotificationFill);
export const BwNotificationLine = withBwIconProps(NotificationLine);
export const BwNotificationPlusLine = withBwIconProps(NotificationPlusLine);
export const BwNumberedListLine = withBwIconProps(NumberedListLine);
export const BwOnboardingSessionAvatars = withBwIconProps(
  OnboardingSessionAvatars,
);
export const BwOrderTypeBilling = withBwIconProps(OrderTypeBilling);
export const BwOrderTypeNew = withBwIconProps(OrderTypeNew);
export const BwOrderTypeProgress = withBwIconProps(OrderTypeProgress);
export const BwOrderTypeReview = withBwIconProps(OrderTypeReview);
export const BwOrderTypeSchedule = withBwIconProps(OrderTypeSchedule);
export const BwOutlook = withBwIconProps(Outlook);
export const BwOwlAiColor = withBwIconProps(OwlAiColor);
export const BwPaintingPaletteLine = withBwIconProps(PaintingPaletteLine);
export const BwPapePlaneLight = withBwIconProps(PapePlaneLight);
export const BwPaperPlaneLight = withBwIconProps(PaperPlaneLight);
export const BwPasswordSquareLine = withBwIconProps(PasswordSquareLine);
export const BwPauseCircleLine = withBwIconProps(PauseCircleLine);
export const BwPauseLine = withBwIconProps(PauseLine);
export const BwPaymentMethodApplePayDark = withBwIconProps(
  PaymentMethodApplePayDark,
);
export const BwPaymentMethodApplePayLight = withBwIconProps(
  PaymentMethodApplePayLight,
);
export const BwPaymentMethodBankDark = withBwIconProps(PaymentMethodBankDark);
export const BwPaymentMethodBankLight = withBwIconProps(PaymentMethodBankLight);
export const BwPaymentMethodCashDark = withBwIconProps(PaymentMethodCashDark);
export const BwPaymentMethodCashLight = withBwIconProps(PaymentMethodCashLight);
export const BwPaymentMethodCcGenericDark = withBwIconProps(
  PaymentMethodCcGenericDark,
);
export const BwPaymentMethodCcGenericLight = withBwIconProps(
  PaymentMethodCcGenericLight,
);
export const BwPaymentMethodCreditsDark = withBwIconProps(
  PaymentMethodCreditsDark,
);
export const BwPaymentMethodCreditsLight = withBwIconProps(
  PaymentMethodCreditsLight,
);
export const BwPaymentMethodDepositDark = withBwIconProps(
  PaymentMethodDepositDark,
);
export const BwPaymentMethodDepositLight = withBwIconProps(
  PaymentMethodDepositLight,
);
export const BwPaymentMethodGooglePayDark = withBwIconProps(
  PaymentMethodGooglePayDark,
);
export const BwPaymentMethodGooglePayLight = withBwIconProps(
  PaymentMethodGooglePayLight,
);
export const BwPaymentMethodMasterCardDark = withBwIconProps(
  PaymentMethodMasterCardDark,
);
export const BwPaymentMethodMasterCardLight = withBwIconProps(
  PaymentMethodMasterCardLight,
);
export const BwPaymentMethodPaypalDark = withBwIconProps(
  PaymentMethodPaypalDark,
);
export const BwPaymentMethodPaypalLight = withBwIconProps(
  PaymentMethodPaypalLight,
);
export const BwPaymentMethodVisaDark = withBwIconProps(PaymentMethodVisaDark);
export const BwPaymentMethodVisaLight = withBwIconProps(PaymentMethodVisaLight);
export const BwPdfAttachment = withBwIconProps(PdfAttachment);
export const BwPenEngineeringLine = withBwIconProps(PenEngineeringLine);
export const BwPenLine = withBwIconProps(PenLine);
export const BwPenRulerCrossLine = withBwIconProps(PenRulerCrossLine);
export const BwPenRulerLine = withBwIconProps(PenRulerLine);
export const BwPen = withBwIconProps(Pen);
export const BwPencilLine = withBwIconProps(PencilLine);
export const BwPhoneHandLight = withBwIconProps(PhoneHandLight);
export const BwPhoneNumberPad = withBwIconProps(PhoneNumberPad);
export const BwPin1Fill = withBwIconProps(Pin1Fill);
export const BwPinLine = withBwIconProps(PinLine);
export const BwPinListLine = withBwIconProps(PinListLine);
export const BwPinRemoveLine = withBwIconProps(PinRemoveLine);
export const BwPlaceCalendarDark = withBwIconProps(PlaceCalendarDark);
export const BwPlaceCalendarLight = withBwIconProps(PlaceCalendarLight);
export const BwPlaceDark = withBwIconProps(PlaceDark);
export const BwPlaceHouseIcon = withBwIconProps(PlaceHouseIcon);
export const BwPlaceJournalDark = withBwIconProps(PlaceJournalDark);
export const BwPlaceJournalLight = withBwIconProps(PlaceJournalLight);
export const BwPlaceJournal = withBwIconProps(PlaceJournal);
export const BwPlaceLight = withBwIconProps(PlaceLight);
export const BwPlaceOverview = withBwIconProps(PlaceOverview);
export const BwPlayFill = withBwIconProps(PlayFill);
export const BwPlayLine = withBwIconProps(PlayLine);
export const BwPlusLine = withBwIconProps(PlusLine);
export const BwPocketBookHeartLine = withBwIconProps(PocketBookHeartLine);
export const BwPptAttachment = withBwIconProps(PptAttachment);
export const BwPrimaryContactLight = withBwIconProps(PrimaryContactLight);
export const BwProfitDark = withBwIconProps(ProfitDark);
export const BwProfitLight = withBwIconProps(ProfitLight);
export const BwProgressCircularLine15 = withBwIconProps(ProgressCircularLine15);
export const BwProgressCircularLine25 = withBwIconProps(ProgressCircularLine25);
export const BwProgressCircularLine35 = withBwIconProps(ProgressCircularLine35);
export const BwProgressCircularLine45 = withBwIconProps(ProgressCircularLine45);
export const BwProgressCircularLine55 = withBwIconProps(ProgressCircularLine55);
export const BwProgressDark = withBwIconProps(ProgressDark);
export const BwProgressLight = withBwIconProps(ProgressLight);
export const BwQrCode = withBwIconProps(QrCode);
export const BwQrScanLine = withBwIconProps(QrScanLine);
export const BwQuestionMarkCircleFill = withBwIconProps(QuestionMarkCircleFill);
export const BwQuestionMarkCircleLine = withBwIconProps(QuestionMarkCircleLine);
export const BwQuotationCloseLine = withBwIconProps(QuotationCloseLine);
export const BwQuotationOpenLine = withBwIconProps(QuotationOpenLine);
export const BwReceiptBillCloseLine = withBwIconProps(ReceiptBillCloseLine);
export const BwReceiptBillLine = withBwIconProps(ReceiptBillLine);
export const BwReceiptBillTimeFill = withBwIconProps(ReceiptBillTimeFill);
export const BwReceiptBillTimeLine = withBwIconProps(ReceiptBillTimeLine);
export const BwReceiptDark = withBwIconProps(ReceiptDark);
export const BwReceiptLight = withBwIconProps(ReceiptLight);
export const BwReceiptPrintDark = withBwIconProps(ReceiptPrintDark);
export const BwReceiptPrintLight = withBwIconProps(ReceiptPrintLight);
export const BwRecordCircleLine = withBwIconProps(RecordCircleLine);
export const BwRecordVideoLine = withBwIconProps(RecordVideoLine);
export const BwRectangleRoundFill = withBwIconProps(RectangleRoundFill);
export const BwRedoLine = withBwIconProps(RedoLine);
export const BwRefreshLoadLeftLine = withBwIconProps(RefreshLoadLeftLine);
export const BwRefreshRightLine = withBwIconProps(RefreshRightLine);
export const BwRefreshSquareLeftLine = withBwIconProps(RefreshSquareLeftLine);
export const BwReplayIconLine = withBwIconProps(ReplayIconLine);
export const BwReplyShareLeftLine = withBwIconProps(ReplyShareLeftLine);
export const BwReportBookDark = withBwIconProps(ReportBookDark);
export const BwReportBookLight = withBwIconProps(ReportBookLight);
export const BwReportBook = withBwIconProps(ReportBook);
export const BwReportJournalDark = withBwIconProps(ReportJournalDark);
export const BwReportJournalLight = withBwIconProps(ReportJournalLight);
export const BwRightDownCircleFill = withBwIconProps(RightDownCircleFill);
export const BwRightLine = withBwIconProps(RightLine);
export const BwRouteLine = withBwIconProps(RouteLine);
export const BwSafeBoxFill = withBwIconProps(SafeBoxFill);
export const BwSafeBoxLine = withBwIconProps(SafeBoxLine);
export const BwScanSquareSliderLine = withBwIconProps(ScanSquareSliderLine);
export const BwScopeLight = withBwIconProps(ScopeLight);
export const BwSearchLibraryLine = withBwIconProps(SearchLibraryLine);
export const BwSearchLine = withBwIconProps(SearchLine);
export const BwSearchSquareTitleLine = withBwIconProps(SearchSquareTitleLine);
export const BwSeenCheckmarkLine = withBwIconProps(SeenCheckmarkLine);
export const BwSendFill = withBwIconProps(SendFill);
export const BwSendLine = withBwIconProps(SendLine);
export const BwSendMessageLine = withBwIconProps(SendMessageLine);
export const BwSettingLine = withBwIconProps(SettingLine);
export const BwSettingToolQuareLine = withBwIconProps(SettingToolQuareLine);
export const BwShareSquareLine = withBwIconProps(ShareSquareLine);
export const BwSheetAttachment = withBwIconProps(SheetAttachment);
export const BwShield1Line = withBwIconProps(Shield1Line);
export const BwShieldDoneLine = withBwIconProps(ShieldDoneLine);
export const BwShieldFill = withBwIconProps(ShieldFill);
export const BwShieldLine = withBwIconProps(ShieldLine);
export const BwShoppingBagPlusLine = withBwIconProps(ShoppingBagPlusLine);
export const BwShoppingCartCheckFill = withBwIconProps(ShoppingCartCheckFill);
export const BwShoppingCartLine = withBwIconProps(ShoppingCartLine);
export const BwSideToLeftSideLine = withBwIconProps(SideToLeftSideLine);
export const BwSideToRightSideFill = withBwIconProps(SideToRightSideFill);
export const BwSideToRightSideLine = withBwIconProps(SideToRightSideLine);
export const BwSmartphoneLine = withBwIconProps(SmartphoneLine);
export const BwSmsAppColor = withBwIconProps(SmsAppColor);
export const BwSnowLine = withBwIconProps(SnowLine);
export const BwSortDownLine = withBwIconProps(SortDownLine);
export const BwSortsComplete = withBwIconProps(SortsComplete);
export const BwSpaceRocketLine = withBwIconProps(SpaceRocketLine);
export const BwSquareMessage1VoiceLine = withBwIconProps(
  SquareMessage1VoiceLine,
);
export const BwStackCheckDark = withBwIconProps(StackCheckDark);
export const BwStackCheckLight = withBwIconProps(StackCheckLight);
export const BwStarGlowingColorLine = withBwIconProps(StarGlowingColorLine);
export const BwStarGlowingLine = withBwIconProps(StarGlowingLine);
export const BwStarLine = withBwIconProps(StarLine);
export const BwStartAChat = withBwIconProps(StartAChat);
export const BwStickerLine = withBwIconProps(StickerLine);
export const BwStopSquareFill = withBwIconProps(StopSquareFill);
export const BwStopwatchFlagLine = withBwIconProps(StopwatchFlagLine);
export const BwStoreFill = withBwIconProps(StoreFill);
export const BwStoreLine = withBwIconProps(StoreLine);
export const BwStrikethroughLine = withBwIconProps(StrikethroughLine);
export const BwSubscriptionDark = withBwIconProps(SubscriptionDark);
export const BwSubscriptionLight = withBwIconProps(SubscriptionLight);
export const BwSubtractDashLine = withBwIconProps(SubtractDashLine);
export const BwSun1Line = withBwIconProps(Sun1Line);
export const BwSunLine = withBwIconProps(SunLine);
export const BwSunOffLine = withBwIconProps(SunOffLine);
export const BwSunriseLine = withBwIconProps(SunriseLine);
export const BwSunsetLine = withBwIconProps(SunsetLine);
export const BwSwapHorizontalSquareLine = withBwIconProps(
  SwapHorizontalSquareLine,
);
export const BwTabClick = withBwIconProps(TabClick);
export const BwTableSquareLine = withBwIconProps(TableSquareLine);
export const BwTagLeftLine = withBwIconProps(TagLeftLine);
export const BwTagLine = withBwIconProps(TagLine);
export const BwTagRightLine = withBwIconProps(TagRightLine);
export const BwTargetCircleLine = withBwIconProps(TargetCircleLine);
export const BwTextAi = withBwIconProps(TextAi);
export const BwTextAttachment = withBwIconProps(TextAttachment);
export const BwTextDirectionLine = withBwIconProps(TextDirectionLine);
export const BwTextFieldLine = withBwIconProps(TextFieldLine);
export const BwTextLine = withBwIconProps(TextLine);
export const BwThumbDislikeFill = withBwIconProps(ThumbDislikeFill);
export const BwThumbDislikeLine = withBwIconProps(ThumbDislikeLine);
export const BwThumbLikeFill = withBwIconProps(ThumbLikeFill);
export const BwThumbLikeLine = withBwIconProps(ThumbLikeLine);
export const BwThumbUpDark = withBwIconProps(ThumbUpDark);
export const BwThumbUpLight = withBwIconProps(ThumbUpLight);
export const BwTimeBookDark = withBwIconProps(TimeBookDark);
export const BwTimeBookLight = withBwIconProps(TimeBookLight);
export const BwTimeCircleFill = withBwIconProps(TimeCircleFill);
export const BwTimeCircleLine = withBwIconProps(TimeCircleLine);
export const BwTimeDashLine = withBwIconProps(TimeDashLine);
export const BwTimeTrackDark = withBwIconProps(TimeTrackDark);
export const BwTimeTrackLight = withBwIconProps(TimeTrackLight);
export const BwTimerCloseLine = withBwIconProps(TimerCloseLine);
export const BwTimerFill = withBwIconProps(TimerFill);
export const BwTimerLine = withBwIconProps(TimerLine);
export const BwTitleCaseLine = withBwIconProps(TitleCaseLine);
export const BwTwoUsersFill = withBwIconProps(TwoUsersFill);
export const BwTwoUsersLine = withBwIconProps(TwoUsersLine);
export const BwUnderlineLine = withBwIconProps(UnderlineLine);
export const BwUndoLine = withBwIconProps(UndoLine);
export const BwUniversityLine = withBwIconProps(UniversityLine);
export const BwUpdateLeftLine = withBwIconProps(UpdateLeftLine);
export const BwUpdateRightLine = withBwIconProps(UpdateRightLine);
export const BwUploadLine = withBwIconProps(UploadLine);
export const BwUserBackgroundBlurNoneLine = withBwIconProps(
  UserBackgroundBlurNoneLine,
);
export const BwUserBackgroundBlurThickLine = withBwIconProps(
  UserBackgroundBlurThickLine,
);
export const BwUserBackgroundBlurThinLine = withBwIconProps(
  UserBackgroundBlurThinLine,
);
export const BwUserCardDark = withBwIconProps(UserCardDark);
export const BwUserCardLight = withBwIconProps(UserCardLight);
export const BwUserCircleFill = withBwIconProps(UserCircleFill);
export const BwUserCircleLine = withBwIconProps(UserCircleLine);
export const BwUserIdCardDark = withBwIconProps(UserIdCardDark);
export const BwUserIdCardHangDark = withBwIconProps(UserIdCardHangDark);
export const BwUserIdCardHangLight = withBwIconProps(UserIdCardHangLight);
export const BwUserIdCardLight = withBwIconProps(UserIdCardLight);
export const BwUserInformationIdFill = withBwIconProps(UserInformationIdFill);
export const BwUserInformationIdLine = withBwIconProps(UserInformationIdLine);
export const BwUserLine = withBwIconProps(UserLine);
export const BwUserPenLine = withBwIconProps(UserPenLine);
export const BwUserScanLine = withBwIconProps(UserScanLine);
export const BwUserShieldLine = withBwIconProps(UserShieldLine);
export const BwUserStarLine = withBwIconProps(UserStarLine);
export const BwUserStripeLine = withBwIconProps(UserStripeLine);
export const BwUsersLine = withBwIconProps(UsersLine);
export const BwVideoAttachment = withBwIconProps(VideoAttachment);
export const BwVideoCameraLine = withBwIconProps(VideoCameraLine);
export const BwVideoDark = withBwIconProps(VideoDark);
export const BwVideoLight = withBwIconProps(VideoLight);
export const BwWaitListDark = withBwIconProps(WaitListDark);
export const BwWaitListLight = withBwIconProps(WaitListLight);
export const BwWalkFill = withBwIconProps(WalkFill);
export const BwWalletCardsDark = withBwIconProps(WalletCardsDark);
export const BwWalletCardsLight = withBwIconProps(WalletCardsLight);
export const BwWarningCircleFill = withBwIconProps(WarningCircleFill);
export const BwWarningCircleLine = withBwIconProps(WarningCircleLine);
export const BwWarningSquareLine = withBwIconProps(WarningSquareLine);
export const BwWarningTriangleLine = withBwIconProps(WarningTriangleLine);
export const BwWavingHandLine = withBwIconProps(WavingHandLine);
export const BwWhatsappColor = withBwIconProps(WhatsappColor);
export const BwWindowDockedSidepanelLine = withBwIconProps(
  WindowDockedSidepanelLine,
);
export const BwWordAttachment = withBwIconProps(WordAttachment);
export const BwWorkFill = withBwIconProps(WorkFill);
export const BwWorldNetwork = withBwIconProps(WorldNetwork);
export const BwWrenchLine = withBwIconProps(WrenchLine);
export const BwYahoo = withBwIconProps(Yahoo);
export const BwZoomInLine = withBwIconProps(ZoomInLine);
export const BwZoomOutLine = withBwIconProps(ZoomOutLine);
